import { combineReducers } from 'redux';
import plans from './planReducer';
import planDetail from './planDetailReducer';
import loans from './loanReducer';
import loanDetail from './loanDetailReducer';
import transactionReducer from "./transactionReducer";
import authReducer from './authReducer';
import errorReducer from './errorReducer';
import customerReducer from './customerReducer';
import paymentReducer from './paymentReducer';
import loanPaymentReducer from './loanPaymentReducer';
import configReducer from './configReducer';

import { reducer as formReducer } from 'redux-form';
import { connectRouter } from 'connected-react-router';

const createRootReducer = (history) => combineReducers({
	router: connectRouter(history),
	auth: authReducer,
	form: formReducer,
	error: errorReducer,
	pageData: customerReducer,
	plans: plans,
	planDetail: planDetail,
	loans: loans,
	loanDetail: loanDetail,
	transactions: transactionReducer,
	payments: paymentReducer,
	loanPayments: loanPaymentReducer,
	init: configReducer,
});

export type RootState = ReturnType<ReturnType<typeof createRootReducer>>; 

export default createRootReducer;

